module.exports = __webpack_public_path__ + "mainassets/img/rule_1.3ea51be1.jpg";